<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <!-- <a-col :md="5" :sm="24">
              <a-form-item label="所属分类" prop="problemTypeId">
                <a-input v-model="queryParam.problemTypeName" placeholder="请输入所属分类" allow-clear/>
              </a-form-item>
            </a-col> -->
            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('problem.title')" prop="title">
                <a-input v-model="queryParam.title" :placeholder="$t('problem.inputTitle')" allow-clear/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="5" :sm="24">
                <a-form-item :label="$t('problem.sketch')" prop="sketch">
                  <a-input v-model="queryParam.sketch" :placeholder="$t('problem.inputSketch')" allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('common.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('common.reset') }}</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['problem:problem:add']">
          <a-icon type="plus" />{{ $t('common.add') }}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['problem:problem:edit']">
          <a-icon type="edit" />{{ $t('common.edit') }}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['problem:problem:remove']">
          <a-icon type="delete" />{{ $t('common.delete') }}
        </a-button>
        <!-- <a-button type="primary" @click="handleExport" v-hasPermi="['problem:problem:export']">
          <a-icon type="download" />导出
        </a-button> -->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        :problemTypeOptions="problemTypeOptions"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 2000 }"
      >
        <span slot="status" slot-scope="text, record">
          <a-popconfirm :ok-text="$t('problem.confirmStatus')" @confirm="handleStatusType(record)">
            <span slot="title">{{ $t('problem.confirmStatus') }}<b>{{ record.status === 0 ? $t('problem.enable') : $t('problem.disable') }}</b>
              {{ record.title }}{{ $t('problem.statusConfirm') }}
            </span>
            <a-switch :checked-children="$t('problem.open')" :un-checked-children="$t('problem.close')" :checked="record.status === 1"/>
          </a-popconfirm>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>

        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['problem:problem:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['problem:problem:edit']">
            <a-icon type="edit" />{{ $t('common.edit') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['problem:problem:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['problem:problem:remove']">
            <a-icon type="delete" />{{ $t('common.delete') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => $t('table.total', { total })"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {pageProblem, listProblem, delProblem, editProblemStatus, listProblemType} from '@/api/problem/problem'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import {listGroup} from "@/api/customerservice/group";

export default {
  name: 'Problem',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      problemTypeOptions:[],
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        problemTypeName: null,
        title: null,
        sketch: null,
        contentInfo: null,
        status: null,
        pageNum: 1,
        pageSize: 10
      },
    }
  },
  filters: {
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('table.index'),
          dataIndex: 'id',
          align: 'center'
        },
        {
          title: this.$t('problem.title'),
          dataIndex: 'titleIn',
          align: 'center'
        },
        {
          title: this.$t('problem.titleEn'),
          dataIndex: 'titleEn',
          align: 'center'
        },
        {
          title: this.$t('problem.titleCn'),
          dataIndex: 'titleCn',
          align: 'center'
        },
        {
          title: this.$t('problem.titleArabic'),
          dataIndex: 'title',
          align: 'center'
        },
        {
          title: this.$t('problem.content'),
          dataIndex: 'contentInfoIn',
          align: 'center'
        },
        {
          title: this.$t('problem.contentEn'),
          dataIndex: 'contentInfoEn',
          align: 'center'
        },
        {
          title: this.$t('problem.contentCn'),
          dataIndex: 'contentInfoCn',
          align: 'center'
        },
        {
          title: this.$t('problem.contentArabic'),
          dataIndex: 'contentInfo',
          align: 'center'
        },
        {
          title: this.$t('problem.sort'),
          dataIndex: 'orderSort',
          align: 'center'
        },
        {
          title: this.$t('problem.status'),
          dataIndex: 'status',
          scopedSlots: {customRender: 'status'},
          align: 'center'
        },
        {
          title: this.$t('problem.createTime'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
        {
          title: this.$t('common.operation'),
          dataIndex: 'operation',
          width: 150,
          scopedSlots: { customRender: 'operation' },
          align: 'center',
          fixed: 'right'
        }
      ]
    }
  },
  created () {
    this.getList()
    this.getProblemTypeOptions();
  },
  watch: {
  },
  methods: {
    /** 查询常见问题列表 */
    getList () {
      this.loading = true
     pageProblem(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    /** 查询所属分类 */
    getProblemTypeOptions () {
      listProblemType().then(response => {
        this.problemTypeOptions = response.data
      })
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        problemTypeId: undefined,
        title: undefined,
        sketch: undefined,
        contentInfo: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    // onShowSizeChange 方法已在 tableMixin 中统一处理，无需重复定义
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    // 状态修改
    handleStatusType(row) {
      row.status = row.status == '0' ? '1' : '0'
      editProblemStatus(row.id, row.status).then(() => {
        this.$message.success(this.$t('problem.operationSuccess'))
        this.getList()
      }).catch(function () {
        row.status = row.status == '0' ? '1' : '0'
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('problem.confirmDelete'),
        content: this.$t('problem.confirmDeleteContent') + ids,
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delProblem(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('common.deleteSuccess'),
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    // handleExport () {
    //   var that = this
    //   this.$confirm({
    //     title: '是否确认导出?',
    //     content: '此操作将导出当前条件下所有数据而非选中数据',
    //     onOk () {
    //       that.download('problem/problem/export', {
    //         ...that.queryParam
    //       }, `常见问题_${new Date().getTime()}.xlsx`)
    //     },
    //     onCancel () {}
    //   })
    // }
  }
}
</script>
